import React from 'react';

const IconSearch = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
            <path d="M9.0625 15.875C12.6869 15.875 15.625 12.9369 15.625 9.3125C15.625 5.68813 12.6869 2.75 9.0625 2.75C5.43813 2.75 2.5 5.68813 2.5 9.3125C2.5 12.9369 5.43813 15.875 9.0625 15.875Z" stroke="var(--neutral_active)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M13.7031 13.9531L17.5 17.75" stroke="var(--neutral_active)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
};

export default IconSearch;